import React from 'react';
import { Box, Card, Grid } from '@material-ui/core';
import { Captions, LongBody, SmallSectionHeader } from 'components/Typography';
import styled from 'styled-components';

export const Wrapper = styled(Box)`
  border-radius: 8px;
  padding: 16px 24px;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.03), 0 0 24px 0 rgba(0, 0, 0, 0.08);
  background: white;
  padding-bottom: 0px;
`;

export const ItemsWrapper = styled(Card)<{ isArabic: boolean }>`
  && {
    box-sizing: border-box;
    border: 1px solid #c2d1d9;
    background: white;
    border-radius: 8px;
    padding: 20px 0px;
    box-shadow: none;
    height: 100%;
    direction: ${({ isArabic }) => (isArabic ? 'rtl' : 'ltr')};
  }
`;

export const BlocTitle = styled(SmallSectionHeader)`
  && {
    letter-spacing: 0;
    line-height: 23px;
    margin-left: 8px;
  }
`;

export const BodyTitle = styled(LongBody)`
  && {
    margin-bottom: 20px;
    line-height: 19px;
  }
`;

export const StyledCaptions = styled(
  ({ isMarginBottom, lineHeight, ...otherProps }) => (
    <Captions {...otherProps} />
  ),
)`
  &&& {
    margin-bottom: ${({ isMarginBottom }) => (isMarginBottom ? '8px' : '0px')};
    line-height: ${({ lineHeight }) => lineHeight};
  }
`;

export const SizedCaptions = styled(Captions)`
  && {
    margin-bottom: 8px;
    font-size: 11px;
    line-height: 18px;
  }
`;

export const ButtonItem = styled(Box)`
  cursor: pointer;
  display: flex;
`;
export const FullHighedGrid = styled(Grid)`
  height: 100%;
`;

export const StyledGrid = styled(Grid)`
  && {
    flex-grow: 0;
  }
`;
